import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import CTABand from "@/components/CTABand";
import { BtnGhost } from "@/components/Btn";
import { TechLabel } from "@/components/Bits";
import usePageMeta from "@/hooks/usePageMeta";
import { SERVICES } from "@/config/company";
import { Plus } from "lucide-react";

export default function Servizi() {
  usePageMeta(
    "Servizi — MMC S.r.l. | Carpenteria Metallica",
    "Carpenteria pesante e leggera, saldatura certificata, costruzioni e manutenzioni industriali: i servizi di MMC S.r.l. in provincia di Bergamo."
  );

  return (
    <main>
      <PageHeader
        index="02"
        eyebrow="Servizi"
        title="Servizi"
        sub="Quattro lavorazioni integrate, un unico metodo: dalla materia prima alla struttura finita, seguita da un solo interlocutore."
      />

      <section data-testid="servizi-list" className="px-5 py-16 md:px-10 md:py-24 lg:px-16">
        <div className="mx-auto max-w-7xl">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={0.05}>
              <article
                data-testid={`servizio-card-${s.id}`}
                className="grid gap-10 border-t border-white/10 py-14 md:py-20 lg:grid-cols-12 lg:gap-14"
              >
                <div className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                  <div className="clip-notch relative h-[300px] overflow-hidden border border-white/10 md:h-[420px]">
                    <img
                      src={s.img}
                      alt={s.title}
                      loading={i < 2 ? "eager" : "lazy"}
                      className="h-full w-full object-cover"
                    />
                    <div className="spotlight absolute inset-0" />
                    <TechLabel className="absolute left-4 top-4">
                      Serv. 0{i + 1} — {s.title}
                    </TechLabel>
                  </div>
                </div>
                <div className={`lg:col-span-7 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
                  <span className="font-tech text-sm text-molten">/0{i + 1}</span>
                  <h2 className="mt-4 font-display text-3xl font-semibold uppercase tracking-tight sm:text-4xl lg:text-5xl">
                    {s.title}
                  </h2>
                  <p className="mt-6 max-w-2xl text-base leading-relaxed text-fog md:text-lg">{s.desc}</p>
                  <TechLabel className="mt-10 block">Vantaggi per il cliente</TechLabel>
                  <ul className="mt-5 space-y-3">
                    {s.benefits.map((b) => (
                      <li key={b} className="flex items-start gap-3 text-sm text-white/85 md:text-base">
                        <Plus className="mt-0.5 size-4 shrink-0 text-molten" />
                        {b}
                      </li>
                    ))}
                  </ul>
                  <BtnGhost to="/contatti" testid={`servizio-cta-${s.id}`} className="mt-9">
                    Richiedi informazioni
                  </BtnGhost>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      <CTABand />
    </main>
  );
}
